const REQUIRED_FIELDS = [
    'maxHeartRate',
    'trainingHeartRate',
    'minTrainingHeartRate',
    'restingHeartRate'
];
const OPTIONAL_FIELDS = ['anaerobicThreshold', 'ventilatoryThreshold'];

const positiveNumber = (value) => {
    if (!['number', 'string'].includes(typeof value) || String(value).trim() === '')
        return null;
    const number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : null;
};

export const normalizeRecordThresholds = (values) => {
    if (!values || typeof values !== 'object' || Array.isArray(values)) return null;
    const thresholds = {};
    for (const field of REQUIRED_FIELDS) {
        const value = positiveNumber(values[field]);
        if (value === null) return null;
        thresholds[field] = value;
    }
    if (
        thresholds.minTrainingHeartRate > thresholds.trainingHeartRate ||
        thresholds.trainingHeartRate > thresholds.maxHeartRate ||
        thresholds.restingHeartRate >= thresholds.maxHeartRate
    )
        return null;
    for (const field of OPTIONAL_FIELDS) {
        const value = positiveNumber(values[field]);
        if (value !== null) thresholds[field] = value;
    }
    return thresholds;
};

export const resolveRecordThresholds = (
    record,
    profile,
    { allowProfileFallback = false } = {}
) => {
    const snapshot = record?.config?.thresholds;
    const historical = normalizeRecordThresholds(snapshot);
    if (historical)
        return {
            thresholds: historical,
            source: 'record',
            historicalStatus: 'valid',
            needsProfile: false
        };
    const historicalStatus = snapshot == null ? 'missing' : 'invalid';
    const needsProfile = historicalStatus === 'missing' || allowProfileFallback;
    const thresholds = needsProfile ? normalizeRecordThresholds(profile) : null;
    return {
        thresholds,
        source: thresholds ? 'profile' : null,
        historicalStatus,
        needsProfile
    };
};
